import { DatePicker, Form } from "antd";
import dayjs from "dayjs";
import { useParams } from "react-router";
import axiosInstance, { api } from "../common/api";
import { requiredField } from "../common/common";
import DebounceSelect from "../common/DebounceSelect";
import SimpleFormPage from "../common/SimpleFormPage";

export default function () {
  const { id } = useParams();

  return (
    <SimpleFormPage
      title="Nuova richiesta POS"
      transformData={(form) => ({
        ...form,
        workSite: Number(id),
        employees: form.employees ?? [],
        vehicles: form.vehicles ?? [],
      })}
    >
      <Form.Item
        label="Data prevista di emissione"
        name="expectedDueDate"
        rules={[requiredField]}
        getValueProps={(value) => ({ value: value && dayjs(value) })}
        normalize={(value) => value && value.format("YYYY-MM-DD")}
      >
        <DatePicker format="DD-MM-YYYY" />
      </Form.Item>
      <Form.Item label="Dipendenti" name="employees">
        <DebounceSelect
          mode="multiple"
          labelInValue={false}
          minSize={1}
          fetchOptions={(query) =>
            axiosInstance
              .get("employee", { params: { query, pageSize: 9999 } })
              .then(({ data }) => data.data.map((x) => ({ label: x.fullName, value: x.id })))
          }
        />
      </Form.Item>
      <Form.Item label="Veicoli" name="vehicles">
        <DebounceSelect
          mode="multiple"
          labelInValue={false}
          minSize={1}
          fetchOptions={(plate) =>
            api.vehicle.list({ plate, pageSize: 9999 }).then((data) =>
              data.data.map((x) => ({ label: `${x.plate} • ${x.description}`, value: x.id })),
            )
          }
        />
      </Form.Item>
    </SimpleFormPage>
  );
}
